var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQoute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.587 0h3.11L3.112 21H0L9.586 0z",
    fill: "#FFBC00"
  })));
}
export default __webpack_public_path__ + "0db2e396bacec4d707bcf9b3cc888a71.svg";
export { SvgQoute as ReactComponent };